<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('achievement')">
            <a :href="urlGenerator('/hotel/achievement-category')" v-if="$can('view_hotel_achievement')"
               class="btn btn-success btn-with-shadow mr-1">
                <app-icon name="list" class="size-20 mr-1"/>
                {{ $t('categories') }}
            </a>
            <app-default-button
                class="mr-1"
                :title="$fieldTitle('add', 'category', true)"
                v-if="$can('view_hotel_achievement')"
                @click="openModalCategory()"
            />
            <app-default-button
                :title="$fieldTitle('add', 'achievement', true)"
                v-if="$can('create_hotel_achievement')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="hotel-achievement-table"
            :options="options"
            @action="triggerActions"
            @getFilteredValues="getFilterValues"
        />

        <app-hotel-achievement-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-hotel-achievement-category-create
            v-if="isModalCategoryActive"
            v-model="isModalCategoryActive"
            :selected-url="selectedUrl"
            @close="isModalCategoryActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('hotel-achievement-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";
import HotelAchievementMixins from "../../../Mixins/HotelAchievementMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "AppHotelAchievement",
    mixins: [HelperMixin, HotelAchievementMixins, TENANT_BASE_URL],
    data() {
        return {
            urlGenerator,
            isModalCategoryActive: false,
            isModalActive        : false,
            selectedUrl          : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/hotel/achievement/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
        openModalCategory() {
            this.isModalCategoryActive = true;
            this.selectedUrl           = ''
        },
    }
}
</script>
